import { TexturesGroup } from '@types'

export default function findGroupPath(
  groups: TexturesGroup[],
  targetId: number,
  path: { path: number[]; tags: string[] } = { path: [], tags: [] },
): { path: number[]; tags: string[] } | null {
  for (const group of groups) {
    const newPath = {
      path: [...path.path, group?.idGruposDeTexturas],
      tags: [...path.tags, group.nombre],
    }
    if (group?.idGruposDeTexturas === targetId) {
      return newPath
    }

    if (group.subGrupos && group.subGrupos.length > 0) {
      const subPath = findGroupPath(group.subGrupos, targetId, newPath)
      if (subPath) {
        return subPath
      }
    }
  }
  return null
}
